import { render } from "./App.vue?vue&type=template&id=00da87df&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=00da87df&scoped=true&lang=css"

import exportComponent from "/root/funtrain-administration-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00da87df"]])

export default __exports__